import React, { useEffect, useState } from 'react';
import { adminAPI } from '../lib/api';
import { toast } from 'sonner';
import { Activity, UserPlus, FolderKanban } from 'lucide-react';

const AdminActivity = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await adminAPI.getActivity(50);
        setEvents(data.events);
      } catch (e) {
        toast.error(e.response?.data?.detail || 'Failed to load activity');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading)
    return <div className="p-8 text-sm" style={{ color: 'var(--c-ink-2)' }}>Loading activity…</div>;

  return (
    <div className="p-8" data-testid="admin-activity">
      <div className="page-header -mx-8 -mt-8 mb-8 px-8 py-6">
        <p className="eyebrow">Portal administration</p>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight" style={{ fontFamily: 'Chivo, sans-serif', color: 'var(--c-ink)' }}>
          Activity
        </h1>
        <p className="mt-1 text-sm" style={{ color: 'var(--c-ink-2)' }}>
          The latest signups and projects across the platform.
        </p>
      </div>

      <div className="bento-card p-0 overflow-hidden">
        {events.length === 0 ? (
          <div className="px-6 py-16 text-center text-sm" style={{ color: 'var(--c-ink-3)' }}>
            <Activity className="w-8 h-8 mx-auto mb-3" style={{ color: 'var(--c-ink-3)' }} strokeWidth={1.5} />
            No activity recorded yet.
          </div>
        ) : (
          <ul>
            {events.map((e, idx) => {
              const Icon = e.type === 'user_signup' ? UserPlus : FolderKanban;
              const tint = e.type === 'user_signup' ? 'var(--c-pine-soft)' : '#F8E0D9';
              const color = e.type === 'user_signup' ? 'var(--c-pine)' : 'var(--c-terracotta)';
              return (
                <li
                  key={idx}
                  className="px-6 py-4 flex items-start gap-4"
                  style={{ borderTop: idx > 0 ? '1px solid var(--c-line)' : 'none' }}
                >
                  <div
                    className="w-9 h-9 flex items-center justify-center flex-shrink-0"
                    style={{ background: tint, borderRadius: 4 }}
                  >
                    <Icon className="w-4 h-4" style={{ color }} strokeWidth={1.75} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm" style={{ color: 'var(--c-ink)' }}>{e.label}</p>
                    <p className="text-[11px] mt-0.5" style={{ color: 'var(--c-ink-3)' }}>
                      {e.actor} · {e.created_at ? new Date(e.created_at).toLocaleString() : '—'}
                    </p>
                  </div>
                  <span className={`badge ${e.type === 'user_signup' ? 'badge-success' : 'badge-warning'}`}>
                    {e.type === 'user_signup' ? 'Signup' : 'Project'}
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminActivity;
